<loader-overlay data-testid="previsit-dashboard-loading" *ngIf="vm.loading"></loader-overlay>
<!-- NO INSURANCE or DOCTOR NOT JOINED MINUDOC OR PRE-VISIT DISABLED -->
<div class="o-grid" *ngIf="!vm.loading">
	<div class="o-grid__cell">
		<div class="u-wrapper"
			[ngStyle]="!vm.isInitialized && {'min-height': '200px'}"
			*ngIf="!vm.isInsuredOrNotified || !vm.businessService || (vm.businessService && !vm.businessService.preVisitEnabled)">
			<div class="c-card u-osb-md o-grid__cell--center-h">
				<div class="c-content c-content--lg">
					<div class="o-grid o-grid--center-v"
						*ngIf="!vm.businessService || (vm.businessService && !vm.businessService.preVisitEnabled)">
						<div class="o-grid__cell">
							<!-- use src, otherwise the picture is loaded even if no error! -->
							<img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/service_not_accessible.svg" />
							<br />
							<h1 class="c-text c-text--heading c-text--s6 c-text--lg">{{'PreVisit.Card_List.Cant_Use_Service' | translate}}</h1>
							<br />
							<p>{{vm.cantUseServiceReason}}</p>
							<br />
							<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up u-no-p">
								<a style="min-width:210px;margin:10px;" *ngIf="vm.hideBackButton && vm.hasOtherPersonActivated" (click)="vm.clearPreVisitData()" class="c-button c-button--s1 c-button--lg">{{'PreVisit.Insert_For_Person_List.Button_Myself' | translate}}</a>
								<a style="min-width:210px;margin:10px;" *ngIf="!vm.hideBackButton" (click)="vm.clearPreVisitData()" class="c-button c-button--s1 c-button--lg">{{'Common.Back' | translate}}</a>
								<a style="min-width:210px;margin:10px;" *ngIf="!vm.insuranceData.errorCode" (click)="vm.goToInsertForPersonList()" class="c-button c-button--s1 c-button--lg">{{'PreVisit.Insert_For_Person_List.Button_Care_Taken' | translate}}</a>
							</div>
						</div>
					</div>
					<div class="o-grid o-grid--center-v"
						*ngIf="!vm.isInsuredOrNotified && vm.businessService && vm.businessService.preVisitEnabled">
						<div class="o-grid__cell">
							<br />
							<p>{{vm.cantUseServiceReason}}</p>
							<br />
							<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up u-no-p">
								<a (click)="vm.clearPreVisitData()"
									class="c-button c-button--s1 c-button--lg c-button--fit@up-to-sm u-osb-md u-osr-md">
									{{'Common.Back' | translate}} </a>
								<button type="button"
									(click)="vm.setPatientInformedOfUninsured()"
									class="c-button c-button--s1 c-button--lg c-button--fit@up-to-sm">
									{{'Common.Next' | translate}}</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!--IS INSURED and HAS DOCTOR and PRE-VISIT ENABLED -->
<div data-testid="previsit-dashboard-ready"
	*ngIf="vm.isInsuredOrNotified && vm.businessService && vm.businessService.preVisitEnabled && !vm.loading">
	<div class="o-grid o-grid--wrap">
		<h2
			class="c-text c-text--heading c-text--xl u-osb-lg o-grid__cell--w-100 o-grid__cell"
			id="preVisitGreetingWithName">{{'Common.Hi' | translate}}, {{ vm.user?.firstname }} {{ vm.user?.lastname }}!</h2>
		<div
			class="o-grid__cell--w-100 o-grid__cell--w-30@md-and-up o-grid__cell">
			<div class="c-card u-osb-md" [ngClass]="{'c-card__header--s1': !vm.user?.previsitUser, 'c-card__header--s2': vm.user?.previsitUser}">
				<div class="c-content" [ngClass]="{'c-text--s4': !vm.user?.previsitUser, 'c-text--s17': vm.user?.previsitUser}">
					<div class="o-grid o-grid--center-v">
						<div class="o-grid__cell">
							<h3 class="c-text">{{'PreVisit.Card_List.Your_Doctor' | translate}} {{vm.doctorName}}.</h3>
							<br />
							<div *ngIf="vm.doctorWebsite">
								<a id="doctorWebsiteLink" href="{{vm.doctorWebsite}}"
									target="_blank" [style.color]="vm.websiteLinkColor"> <img
									id="doctorWebsiteIcon" alt="Website icon"
									[attr.src]="'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/website-white-icon' + vm.websiteImageSuffix + '.svg'"
									height="20px" width="20px" style="vertical-align: bottom;">
									<span> {{'PreVisit.Card_List.Your_Doctor_Website' | translate}}</span>
								</a>
								<br>
								<br>
							</div>
							<p class="c-text">{{'PreVisit.Card_List.Before_Visit' | translate}}</p>
							<br />
							<p class="c-text">{{'PreVisit.Card_List.What_Happens' | translate}}</p>
							<br />
							<p class="c-text">{{'PreVisit.Card_List.Instructions' | translate}}</p>
							<br />
							<h3 class="c-text">{{'PreVisit.Card_List.In_Emergency' | translate}}</h3>
						</div>
					</div>
				</div>
			</div>

			<div class="c-card u-osb-sm u-hidden@up-to-md" *ngIf="vm.parentCategory">
				<div class="c-content">
					<div class="o-grid o-grid--center-v">
						<div class="o-grid__cell u-no-p">
							<h3 class="c-text">
								<a id="preVisitBackToStartLink" [routerLink]="['/pre-visit']" class="c-button--fit"
									[ngStyle]="vm.user?.previsitUser && {'color': 'black'}">{{'Common.Back' | translate}}</a>
							</h3>
						</div>
					</div>
				</div>
			</div>

			<div class="c-card u-osb-sm" *ngIf="vm.isRecordTicketForPerson">
				<div class="c-content">
					<div class="o-grid o-grid--center-v">
						<div class="o-grid__cell u-no-p">
							<h3 class="c-text">
								<a id="preVisitClearInsertForPersonLink"
									(click)="vm.clearRecordTicketForPatientData()"
									style="cursor: pointer;"
									[ngStyle]="vm.user?.previsitUser && {'color': 'black'}">
									{{'PreVisit.Card_List.PreVisit_Clear_Insert_For_Person' | translate}} &#8594; </a>
							</h3>
						</div>
					</div>
				</div>
			</div>

			<div class="c-card u-osb-sm"
				*ngIf="vm.isRecordTicketForPerson && vm.isRegistrator">
				<div class="c-content">
					<div class="o-grid o-grid--center-v">
						<div class="o-grid__cell u-no-p">
							<h3 class="c-text">
								<a id="preVisitUpdatePatientPersonalDetailsLink"
									(click)="vm.updatePatientPersonalDetails()"
									style="cursor: pointer;"
									[ngStyle]="vm.user?.previsitUser && {'color': 'black'}">
									{{'PreVisit.Card_List.PreVisit_Update_Patient_Personal_Details' | translate}} &#8594; </a>
							</h3>
						</div>
					</div>
				</div>
			</div>

			<div class="u-hidden@md-and-up" style="padding-bottom: 10px;">
				<item-notification icon="attention"
					[text]="vm.secondPersonWarningLeft" [theme]="5"></item-notification>
			</div>

			<div class="c-card u-osb-sm" *ngIf="!vm.isRecordTicketForPerson">
				<div class="c-content">
					<div class="o-grid o-grid--center-v">
						<div class="o-grid__cell u-no-p">
							<h3 class="c-text">
								<a id="preVisitInsertForPersonLink"
									style="cursor:pointer;"
									(click)="vm.goToInsertForPersonList()"
									[ngStyle]="vm.user?.previsitUser && {'color': 'black'}">{{'PreVisit.Card_List.PreVisit_Insert_For_Person' | translate}} &#8594;</a>
							</h3>
						</div>
					</div>
				</div>
			</div>

			<div class="c-card u-osb-sm"
				*ngIf="!vm.isRecordTicketForPerson && !vm.user?.previsitUser">
				<div class="c-content">
					<div class="o-grid o-grid--center-v">
						<div class="o-grid__cell u-no-p">
							<h3 class="c-text">
								<a id="preVisitGoToPaidServicesLink" href="">{{'PreVisit.Card_List.Minudoc_Link' | translate}} &#8594;</a>
							</h3>
						</div>
					</div>
				</div>
			</div>

			<div class="c-card u-osb-sm" *ngIf="!vm.isRecordTicketForPerson">
				<div class="c-content">
					<div class="o-grid o-grid--center-v">
						<div class="o-grid__cell u-no-p">
							<h3 class="c-text">
								<a id="preVisitHistoryLink" 
									[routerLink]="['/bookings/pre-visit']"
									[ngStyle]="vm.user?.previsitUser && {'color': 'black'}">{{'PreVisit.Card_List.My_Pre_Visit_History' | translate}} &#8594;</a>
							</h3>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--  RIGHT SECTION-->
		<div *ngIf="vm.settings" 
			class="o-grid o-grid__cell--w-100 o-grid__cell--w-67@md-and-up o-grid--wrap">
			<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-90@lg-and-up u-hidden@up-to-md" style="padding-bottom: 20px;">
				<item-notification icon="attention" [text]="vm.secondPersonWarningMain" [theme]="5"></item-notification>
			</div>
			<div class="o-grid__cell o-grid__cell--w-100 u-osb-md o-grid__cell--w-50@md-and-up u-osb-md o-grid__cell--w-45@lg-and-up"
				[ngClass]="{'o-grid__cell--w-33@lg-and-up': vm.isNarrow}"
				*ngFor="let service of vm.services.types ; let $index=index">
				<pre-visit-card [service]="service" [isNarrow]="vm.isNarrow" [settings]="vm.settings"></pre-visit-card>
			</div>
		</div>

	</div>
</div>
